
// TRIGGER
export const addTrigger = (values) => (
{
  type: 'ADD_TRIGGER',
  name:values.name,
  meta: {sendServer: true},
})

export const changeTriggerName = data => ({
  type: 'CHANGE_TRIGGER_NAME',
  id:data.id,
  name: data.name,
  value: data.value,
  meta: {sendServer: true},
})

export const selectTrigger = data => ({
  type: 'SELECT_TRIGGER',
  id:data.id,
  meta: {sendServer: false},
})

export const unselectTrigger = data => ({
  type: 'UNSELECT_TRIGGER',
  meta: {sendServer: false},
})

export const deleteTrigger = data => ({
  type: 'DELETE_TRIGGER',
  id:data.id,
  meta: {sendServer: true},
})

export const addECA = data => ({
  type: 'ADD_ECA',
  functionType:data.functionType,
  triggerId:data.triggerId,
  meta: {sendServer: true},
})

export const addFunction = data => ({
  type: 'ADD_FUNCTION',
  parentId:data.parentId,
  argId:data.argId,
  functionType:data.functionType,
  triggerId:data.triggerId,
  meta: {sendServer: true,
    asyncServer: false},
})

export const deleteFunction = data => ({
  type: 'DELETE_FUNCTION',
  id:data.id,
  meta: {sendServer: true},
})

export const selectECA = data => ({
  type: 'SELECT_ECA',
  id:data.id,
  meta: {sendServer: false},
})

export const selectFunctionType = data => ({
  type: 'SELECT_FUNCTION_TYPE',
  id:data.id,
  functionType:data.functionType,
  meta: {sendServer: true},
})

export const changeArgMode = data => ({
  type: 'CHANGE_ARG_MODE',
  id:data.id,
  argId:data.argId,
  argMode:data.argMode,
  returnType:data.returnType,
  meta: {sendServer: true},
})

export const changeArgValue = data => ({
  type: 'CHANGE_ARG_VALUE',
  id:data.id,
  argId:data.argId,
  argValue:data.argValue,
  argMode:data.argMode,
  returnType:data.returnType,
  meta: {sendServer: true},
})

export const createFunction = data => ({
  type: 'CREATE_FUNCTION',
  parentId:data.parentId,
  argId:data.argId,
  argValue:data.argValue,
  argMode:data.argMode,
  meta: {sendServer: true},
})

export const registerChildFunction = data => ({
  type: 'REGISTER_CHILD_FUNCTION',
  id:data.id,
  parentId:data.parentId,
  argId:data.argId,
  meta: {sendServer: true,
    asyncServer: false},
})


export const openArgPanel = data => ({
  type: 'OPEN_ARG_PANEL',
  functionId:data.functionId,
  argId:data.argId,
  returnType:data.returnType,
  meta: {sendServer: false},
})

export const openECAPanel = data => ({
  type: 'OPEN_ECA_PANEL',
  functionId:data.functionId,
  argId:data.argId,
  returnType:data.returnType,
  meta: {sendServer: false},
})

export const closeArgPanel = data => ({
  type: 'CLOSE_ARG_PANEL',
  id:data.id,
  functionId:data.functionId,
  argId:data.argId,
  meta: {sendServer: false},
})
